import { Box, Divider, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import AccomodationInfo from "../../../../../../media/images/icons/AccomodationInfo.svg";
import ArrowDownSVG from "../../../../../../media/images/icons/arrow-down";
import CustomInputLabel from "../../../../../components/CustomInputLabel";
import CustomInput from "../../../../../components/CustomInput";
import CheckCircle from "../../../../../../media/images/icons/check-circle";
import CustomButton from "../../../../../components/CustomButton";
import CustomAutoComplete from "../../../../../components/CustomAutoComplete";
import { useFormik } from "formik";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../../../services/fetcher";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../hooks/useRedux";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../../redux/features/snackbarSlice";
import {
  setDialogStatus,
  setDialogTitle,
  setOpenDialog,
} from "../../../../../../redux/features/dialogSlice";
import { setAccomodationInfo } from "../../../../../../redux/features/ownerSlice";
import { PreventInputAlpha } from "../../../../../../utils/functions";

export default function AccommodationInfo() {
  const [isOpen, setIsOpen] = useState(false);

  const dispatch = useAppDispatch();

  const { accomodationInfo } = useAppSelector((state) => state.owner);

  const [cityInputValue, setCityInputValue] = useState("");
  const [citiesOptions, setCitiesOption] = useState([]);

  const theme = useTheme();

  const toggleBox = () => {
    setIsOpen(!isOpen);
  };

  const accomodationFormik = useFormik({
    initialValues: {
      CityInfo: accomodationInfo?.cityInfo
        ? {
            value: accomodationInfo?.cityInfo?.cityCode,
            label: accomodationInfo?.cityInfo?.cityName,
          }
        : null,
      PostalCode: accomodationInfo?.postalCode || "",
      Address: accomodationInfo?.address || "",
    },
    onSubmit: (values) => {
      postAccoumodation(values);
    },
  });

  const {
    trigger: postAccoumodation,
    isMutating: isPostAccoumodationMutating,
  } = useSWRMutation(
    [
      `/Account/OwnerSetAddressInfo

`,
      localStorage.getItem("access_token"),
    ],

    fetcherPost,
    {
      onSuccess: () => {
        dispatch(setOpenDialog(true));
        dispatch(setDialogStatus("success"));
        dispatch(setDialogTitle("ثبت اطلاعات با موفقیت انجام شد!"));
        dispatch(
          setAccomodationInfo({
            address: accomodationFormik.values.Address,
            cityInfo: {
              cityCode: accomodationFormik.values.CityInfo?.value,
              cityName: accomodationFormik.values.CityInfo?.label,
            },
            postalCode: accomodationFormik.values.PostalCode,
          })
        );
      },
    }
  );

  const { trigger: getCitiesTrigger } = useSWRMutation(
    [`/City/SearchByName`],

    fetcherPost,
    {
      onSuccess: (data) => {
        setCitiesOption((prev) =>
          data.map((item: any) => ({
            label: item.name,
            value: item.code,
          }))
        );
      },
    }
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      cityInputValue &&
        getCitiesTrigger({
          name: cityInputValue || null,
        });
    }, 1000);
    return () => clearTimeout(timer);
  }, [cityInputValue]);

  const handleChangeAutoComplete = (selected: any, type?: string) => {
    console.log(selected);

    switch (type) {
      case "CityInfo":
        accomodationFormik.setFieldValue("CityInfo", selected);
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    accomodationFormik.setValues({
      CityInfo: accomodationInfo?.cityInfo
        ? {
            value: accomodationInfo?.cityInfo?.cityCode,
            label: accomodationInfo?.cityInfo?.cityName,
          }
        : null,
      PostalCode: accomodationInfo?.postalCode || "",
      Address: accomodationInfo?.address || "",
    });
  }, [accomodationInfo]);

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.bgColor.white,
        display: "flex",
        flexDirection: "column",
        border: "1px solid",
        borderColor: theme.palette.bgColor.blueGrey100,
        borderRadius: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "start",
          justifyContent: "space-between",
          padding: "8px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "start",
            gap: "4px",
          }}
        >
          <img width={32} src={AccomodationInfo} alt="" />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "700",
                fontSize: "16px",
              }}
            >
              محل سکونت
            </Typography>
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              شهر، کد پستی، آدرس
            </Typography>
          </Box>
        </Box>
        <CustomButton
          justifyContent="space-between"
          onClick={() => toggleBox()}
          bgColor={isOpen ? "error.light" : theme.palette.secondary[50]}
          title={isOpen ? "بستن جزئیات" : "  مشاهده/ویرایش"}
          fSize="12px"
          fWeight="600"
          rippleColor={
            isOpen ? theme.palette.error.main : theme.palette.secondary.main
          }
          borderColor={isOpen ? "error.main" : "secondary.main"}
          py="10px"
          px="6px"
          gap="4px"
          borderRadius="8px"
          textColor={isOpen ? "error.main" : "secondary.main"}
          icon2={
            <Box
              sx={{
                transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s",
              }}
            >
              <ArrowDownSVG
                size={14}
                color={
                  isOpen
                    ? theme.palette.error.main
                    : theme.palette.secondary.main
                }
              />
            </Box>
          }
        />
      </Box>
      <Box
        sx={{
          overflow: "hidden",
          maxHeight: isOpen ? "1000px" : 0,
          transition: isOpen ? "max-height 0.5s ease" : "max-height 0.2s ease",
          paddingX: "10px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Divider variant="fullWidth" />
        <Box
          sx={{
            // border: "1px solid gray",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box>
            <CustomInputLabel required>{"شهر محل سکونت"}</CustomInputLabel>
            <CustomAutoComplete
              width="100%"
              flex={1}
              mb="0px"
              height="44px"
              borderRadius="10px"
              inputValue={cityInputValue}
              setInputValue={setCityInputValue}
              type={"CityInfo"}
              placeHolder="شهر محل سکونت را وارد کنید..."
              setValue={handleChangeAutoComplete}
              value={accomodationFormik.values.CityInfo}
              // error={loaderType.error}
              // errorMessage={loaderType.errorMessage}
              options={cityInputValue ? citiesOptions : []}
              // innerIcon={
              //   <LocationOutline size={18} color={theme.palette.textColor.light} />
              // }
            />
          </Box>
          <Box>
            <CustomInputLabel>{"کدپستی"}</CustomInputLabel>
            <CustomInput
              name="PostalCode"
              value={accomodationFormik.values.PostalCode}
              handelChange={(e) => {
                if (e.target.value.length > 10) return;
                PreventInputAlpha(e, accomodationFormik.handleChange);
              }}
              placHolder="کد پستی محل سکونت را وارد کنید..."
            />
          </Box>
          <Box>
            <CustomInputLabel>{"آدرس محل سکونت"}</CustomInputLabel>
            <CustomInput
              name="Address"
              value={accomodationFormik.values.Address}
              handelChange={accomodationFormik.handleChange}
              textArea
              placHolder="آدرس شرکت را این قسمت وارد کنید..."
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <CheckCircle size={24} color={theme.palette.success.main} />
            <Typography
              sx={{
                fontSize: "14px",
                color: "success.main",
              }}
            >
              برای اعمال شدن تغییرات حتما ذخیره اطلاعات را بزنید
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              mb: 2,
            }}
          >
            <CustomButton
              flex={1}
              justifyContent="center"
              onClick={() => toggleBox()}
              bgColor={theme.palette.primary[50]}
              title={"انصراف"}
              fSize="16px"
              fWeight="700"
              borderColor={theme.palette.primary.main}
              py="10px"
              px="6px"
              gap="4px"
              borderRadius="6px"
              textColor={theme.palette.primary.main}
            />
            <CustomButton
              loading={isPostAccoumodationMutating}
              flex={1}
              justifyContent="center"
              onClick={() => {
                accomodationFormik.handleSubmit();
              }}
              bgColor={"primary.main"}
              title={"ذخیره اطلاعات"}
              fSize="16px"
              fWeight="700"
              py="10px"
              px="6px"
              gap="4px"
              borderRadius="6px"
              textColor={"#fff"}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
